export default __webpack_public_path__ + "images/logo-full.b002b89be73ea7604c210e9e862b2472.png";